// Personal choices always belong to the signed-in SRM actor, not provider IDs.
export const normalizeSettingsUserId = value => value == null || String(value).trim() === '' ? null : String(value).trim();
function storedAuth() {
  try { return JSON.parse(localStorage.getItem('auth') || 'null'); } catch { return null; }
}
export function personalSettingsUserId(fallback) {
  const auth = storedAuth();
  return normalizeSettingsUserId(auth?.token ? auth.id : fallback);
}
export function readPersonalSetting(userId, makeKey) {
  const actor = personalSettingsUserId(userId);
  if (actor == null) return null;
  const key = makeKey(actor);
  let saved = localStorage.getItem(key);
  if (saved != null) return saved;
  const auth = storedAuth();
  // Only migrate aliases explicitly belonging to this authenticated account.
  // Never scan other actors' partitions or treat a late previous-user ID as one.
  const aliases = [auth?.id, auth?.user?.id, auth?.user?.user_id]
    .filter(value => value != null && String(value) !== actor);
  for (const alias of aliases) {
    const oldKey = makeKey(String(alias));
    saved = localStorage.getItem(oldKey);
    if (saved != null) { localStorage.setItem(key, saved); localStorage.removeItem(oldKey); return saved; }
  }
  return null;
}
export function writePersonalSetting(userId, makeKey, value) {
  const actor = personalSettingsUserId(userId);
  if (actor == null) return false;
  const requested = normalizeSettingsUserId(userId);
  const auth = storedAuth();
  if (requested != null && requested !== actor
    && ![auth?.user?.id, auth?.user?.user_id].some(alias => normalizeSettingsUserId(alias) === requested)) return false;
  localStorage.setItem(makeKey(actor), value);
  return true;
}
